"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var validation_error_1 = require("./validation_error");
exports.Constraint = {
    generic: {
        oneOf: function () {
            var options = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                options[_i] = arguments[_i];
            }
            return {
                definition: {
                    name: "oneOf",
                    settings: { options: options }
                },
                eval: function (value) {
                    if (options.indexOf(value) < 0) {
                        throw new validation_error_1.ValidationError("Not one of the accepted options.");
                    }
                }
            };
        }
    },
    number: {
        integer: {
            definition: {
                name: "integer"
            },
            eval: function (value) {
                if (value % 1 !== 0) {
                    throw new validation_error_1.ValidationError("Not an integer.");
                }
            }
        },
        finite: {
            definition: {
                name: "finite"
            },
            eval: function (value) {
                if (!Number.isFinite(value)) {
                    throw new validation_error_1.ValidationError("Not a finite number.");
                }
            }
        },
        above: function (lowerLimit) {
            return {
                definition: {
                    name: "above",
                    settings: { lowerLimit: lowerLimit }
                },
                eval: function (value) {
                    if (!(value > lowerLimit)) {
                        throw new validation_error_1.ValidationError("Not above " + lowerLimit + ".");
                    }
                }
            };
        },
        below: function (upperLimit) {
            return {
                definition: {
                    name: "below",
                    settings: { upperLimit: upperLimit }
                },
                eval: function (value) {
                    if (!(value < upperLimit)) {
                        throw new validation_error_1.ValidationError("Not below " + upperLimit + ".");
                    }
                }
            };
        },
        atLeast: function (lowerLimit) {
            return {
                definition: {
                    name: "atLeast",
                    settings: { lowerLimit: lowerLimit }
                },
                eval: function (value) {
                    if (!(value >= lowerLimit)) {
                        throw new validation_error_1.ValidationError("Less than " + lowerLimit + ".");
                    }
                }
            };
        },
        atMost: function (upperLimit) {
            return {
                definition: {
                    name: "atMost",
                    settings: { upperLimit: upperLimit }
                },
                eval: function (value) {
                    if (!(value <= upperLimit)) {
                        throw new validation_error_1.ValidationError("Larger than " + upperLimit + ".");
                    }
                }
            };
        }
    },
    string: {
        notEmpty: {
            definition: {
                name: "notEmpty"
            },
            eval: function (value) {
                if (value === "") {
                    throw new validation_error_1.ValidationError("Empty string.");
                }
            }
        },
        length: function (_a) {
            var min = _a.min, max = _a.max;
            return {
                definition: {
                    name: "length",
                    settings: { min: min, max: max }
                },
                eval: function (value) {
                    if (typeof min !== "undefined" && value.length < min) {
                        throw new validation_error_1.ValidationError("String length less than " + min);
                    }
                    else if (typeof max !== "undefined" && value.length > max) {
                        throw new validation_error_1.ValidationError("String length greater than " + max);
                    }
                }
            };
        },
        regex: function (re) {
            return {
                definition: {
                    name: "regex",
                    settings: { expression: re.source }
                },
                eval: function (value) {
                    if (!re.test(value)) {
                        throw new validation_error_1.ValidationError("Regex mismatch.");
                    }
                }
            };
        },
        startsWith: function (prefix) {
            return {
                definition: {
                    name: "startsWith",
                    settings: { prefix: prefix }
                },
                eval: function (value) {
                    if (value.substr(0, prefix.length) !== prefix) {
                        throw new validation_error_1.ValidationError("String does not start with '" + prefix + "'.");
                    }
                }
            };
        },
        endsWith: function (suffix) {
            return {
                definition: {
                    name: "endsWith",
                    settings: { suffix: suffix }
                },
                eval: function (value) {
                    if (value.substr(value.length - suffix.length) !== suffix) {
                        throw new validation_error_1.ValidationError("String does not end with '" + suffix + "'.");
                    }
                }
            };
        }
    },
    map: {
        size: function (_a) {
            var min = _a.min, max = _a.max;
            return {
                definition: {
                    name: "size",
                    settings: { min: min, max: max }
                },
                eval: function (value) {
                    var numKeys = Object.keys(value).length;
                    if (typeof min !== "undefined" && numKeys < min) {
                        throw new validation_error_1.ValidationError("Object size less than " + min);
                    }
                    else if (typeof max !== "undefined" && numKeys > max) {
                        throw new validation_error_1.ValidationError("Object size greater than " + max);
                    }
                }
            };
        }
    },
    array: {
        length: function (_a) {
            var min = _a.min, max = _a.max;
            return {
                definition: {
                    name: "length",
                    settings: { min: min, max: max }
                },
                eval: function (value) {
                    if (typeof min !== "undefined" && value.length < min) {
                        throw new validation_error_1.ValidationError("Array length less than " + min);
                    }
                    else if (typeof max !== "undefined" && value.length > max) {
                        throw new validation_error_1.ValidationError("Array length greater than " + max);
                    }
                }
            };
        },
        includes: function (includedValue) {
            return {
                definition: {
                    name: "includes",
                    settings: { value: includedValue }
                },
                eval: function (value) {
                    if (value.indexOf(includedValue) < 0) {
                        throw new validation_error_1.ValidationError("Value is not included in array.");
                    }
                }
            };
        }
    }
};
//# sourceMappingURL=constraint.js.map